import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, Button, Input, Select, Textarea, Field, Stat, StatusBadge } from "@/components/UI";
import { Plus, Trash, Coins, Trophy, ChartLine, PencilSimple } from "@phosphor-icons/react";
import { toast } from "sonner";
import { PerformerField } from "@/components/VetTable";
import { today } from "./helpers";


export function PregnancyEditModal({ item, user, onClose, onDone }) {
  const [form, setForm] = useState({
    animal_type: item.animal_type || "inek",
    checked_count: item.checked_count ?? 1,
    pregnant_count: item.pregnant_count ?? 0,
    empty_count: item.empty_count ?? 0,
    suspicious_count: item.suspicious_count ?? 0,
    date: (item.date || today()).slice(0, 10),
    vet_name: item.vet_name || "",
    notes: item.notes || "",
  });
  const [saving, setSaving] = useState(false);
  const checked = Number(form.checked_count || 0);
  const preg = Number(form.pregnant_count || 0);
  const empty = Number(form.empty_count || 0);
  const susp = Number(form.suspicious_count || 0);
  const sum = preg + empty + susp;
  const overLimit = sum > checked;

  const submit = async (e) => {
    e.preventDefault();
    if (overLimit) return toast.error("Sonuçların toplamı bakılan sayısını aşamaz");
    setSaving(true);
    try {
      await api.put(`/vet/pregnancy-checks/${item.id}`, {
        ...form,
        vet_name: form.vet_name?.trim() || user?.name || "",
        checked_count: checked, pregnant_count: preg, empty_count: empty, suspicious_count: susp,
      });
      toast.success("Gebelik kontrolü güncellendi");
      onDone();
    } catch (err) {
      toast.error(err?.response?.data?.detail || err?.message || "Hata");
    } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onClose} data-testid="preg-edit-modal">
      <div className="bg-white rounded-md max-w-lg w-full p-6 max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="flex items-start justify-between mb-4">
          <h3 className="heading text-xl">Gebelik Kontrolünü Düzenle</h3>
          <button onClick={onClose} data-testid="preg-edit-close" className="text-2xl text-[#8a938c] hover:text-[#1A1D1A]">×</button>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <Field label="Hayvan Tipi *">
              <Select data-testid="preg-edit-animal-type" value={form.animal_type} onChange={e => setForm({ ...form, animal_type: e.target.value })}>
                <option value="inek">İnek</option>
                <option value="düve">Düve</option>
              </Select>
            </Field>
            <Field label="Bakılan Adet *">
              <Input data-testid="preg-edit-checked" type="number" min="1" required value={form.checked_count} onChange={e => setForm({ ...form, checked_count: e.target.value })} />
            </Field>
          </div>
          <div className="grid grid-cols-3 gap-3">
            <Field label="Gebe (+)"><Input data-testid="preg-edit-pregnant" type="number" min="0" value={form.pregnant_count} onChange={e => setForm({ ...form, pregnant_count: e.target.value })} /></Field>
            <Field label="Boş (GD-)"><Input data-testid="preg-edit-empty" type="number" min="0" value={form.empty_count} onChange={e => setForm({ ...form, empty_count: e.target.value })} /></Field>
            <Field label="Şüpheli"><Input data-testid="preg-edit-susp" type="number" min="0" value={form.suspicious_count} onChange={e => setForm({ ...form, suspicious_count: e.target.value })} /></Field>
          </div>
          {checked > 0 && (
            <div className={`text-xs px-3 py-2 rounded-md border ${overLimit ? "bg-[#fbeee9] border-[#f2d4cb] text-[#8a3a2b]" : "bg-[#E4EEE6] border-[#c2d6c8] text-[#2D4A36]"}`} data-testid="preg-edit-preview">
              {overLimit
                ? <>⚠️ Sonuçlar toplamı ({sum}) bakılan sayısını ({checked}) aşıyor</>
                : <>✓ Gebelik oranı: <b>%{((preg / checked) * 100).toFixed(1)}</b></>}
            </div>
          )}
          <Field label="Tarih *"><Input type="date" data-testid="preg-edit-date" required value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} /></Field>
          <PerformerField label="Kontrol Eden (İşlemi Yapan)" user={user} value={form.vet_name}
            onChange={v => setForm({ ...form, vet_name: v })} testId="preg-edit-vet" />
          <Field label="Notlar"><Textarea data-testid="preg-edit-notes" rows={2} value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} /></Field>
          <div className="flex gap-2 pt-1">
            <Button type="button" variant="secondary" onClick={onClose}>İptal</Button>
            <Button data-testid="preg-edit-submit" type="submit" disabled={overLimit || saving}>{saving ? "Kaydediliyor…" : "Güncelle"}</Button>
          </div>
        </form>
      </div>
    </div>
  );
}

